// Pure, framework-free helpers for MFA management.
// No Vue/auth0 imports, so these are unit-testable without the browser harness.

export function parseOtpAuthenticators (list) {
  if (!Array.isArray(list)) return []
  return list
    .filter(a => a && a.authenticator_type === 'otp' && a.active === true)
    .map(a => ({ id: a.id, name: a.name || 'Authenticator app', active: true }))
}

export function buildAssociateBody () {
  return { authenticator_types: ['otp'] }
}

export function parseAssociateResponse (body) {
  if (!body) return null
  return {
    secret: body.secret || null,
    barcodeUri: body.barcode_uri || null,
    recoveryCodes: Array.isArray(body.recovery_codes) ? body.recovery_codes : []
  }
}

export function mapMfaError (error) {
  const code = (error && (error.error || (error.body && error.body.error))) || null
  const status = (error && error.status) || null
  switch (code) {
    case 'login_required':
    case 'consent_required':
    case 'interaction_required':
      return 'Your session has expired. Please sign in again.'
    case 'invalid_grant':
      return 'The verification code is invalid or has expired. Please try again.'
    case 'access_denied':
      return 'You are not allowed to manage two-factor authentication.'
  }
  if (status === 401 || status === 403) {
    return 'The verification code is invalid or has expired. Please try again.'
  }
  return 'Something went wrong. Please try again.'
}



// WEBPACK FOOTER //
// ./src/utils/mfaHelpers.js